import { useAppSelector, useAppTranslation } from 'app/hooks';
import casino from 'assets/icons/casino_icon.png';
import casino_dark from 'assets/icons/casino_icon_dark.png';
import home from 'assets/icons/home_icon.png';
import home_dark from 'assets/icons/home_icon_dark.png';
import poker from 'assets/icons/poker_icon.png';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { IMG_ALT } from 'consts/app';
import useThemes from 'hooks/useThemes';
import useUserDetail from 'hooks/useUserDetail';
import React, { useEffect, useState } from 'react';
import { BiMenu } from 'react-icons/bi';
import { FaCubes, FaWallet } from 'react-icons/fa';
import { GiReturnArrow } from 'react-icons/gi';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { platformStates } from 'redux/platformSlice';
import HomeSubMenu from '../../features/home/components/Submenu/HomeSubMenu';
import SubFooterMenu from '../../features/home/components/Submenu/SubFooterMenu';
import {
  onChangeAuthPage,
  selectBets,
  selectFutureBets,
  selectIsShowBetForm,
  selectIsShowCashierMenu,
  selectIsShowChatSubMenu,
  selectIsShowHomeMenu,
  selectIsShowSubMenu,
  setIsShowChatSubMenu,
  setShowBetForm,
  setShowCashierMenu,
  setShowHomeMenu,
  setShowSubMenu,
} from '../../features/home/homeSlice';
import ConditionButton from './ConditionButton';
import gameApi from 'api/gameApi';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useCheckKYCForPoker from 'hooks/useCheckKYCForPoker';
import CashierModal from 'features/home/components/Modals/CashierModal';
import { showConfirmModal, showInfoModal } from 'components/Modals/CommonModals';
import WarningIcon from 'assets/icons/WarningIcon';

interface FooterMenuProps {
  isCasino?: boolean;
  isUserLogin?: boolean;
  isShowAllPage?: boolean;
  isStreaming?: boolean;
  isShowAllStreaming?: boolean;
  isBetPage?: boolean;
  onShowChangePasswordPage: () => void;
}

const FooterMenu: React.FunctionComponent<FooterMenuProps> = ({
  onShowChangePasswordPage,
  isCasino = false,
  isUserLogin = false,
  isShowAllPage = false,
  isStreaming = false,
  isShowAllStreaming = false,
  isBetPage = false,
}) => {
  const { currentTheme } = useThemes();
  const t = useAppTranslation();
  const dispatch = useDispatch();
  const platform = useAppSelector(platformStates);
  const isShowBetForm = useAppSelector(selectIsShowBetForm);
  const isShowSubMenu = useAppSelector(selectIsShowSubMenu);
  const isShowCashierMenu = useAppSelector(selectIsShowCashierMenu);
  const isShowHomeMenu = useAppSelector(selectIsShowHomeMenu);
  const isShowChatSubMenu = useAppSelector(selectIsShowChatSubMenu);
  const { isPhone } = useAppSelector(platformStates);
  const bets = useAppSelector(selectBets);
  const futureBets = useAppSelector(selectFutureBets);
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const navigate = useNavigate();
  const handleResponseError = useHandleResponseError();
  const [searchParams, setSearchParams] = useSearchParams();
  const { checkKYC } = useCheckKYCForPoker();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handlePokerClick = async () => {
    if (!isUserLoggedIn) {
      window.open(process.env.REACT_APP_POKER_URL, '_blank');
      return;
    }
    setIsLoading(true);
    const { ok, body, error } = await gameApi.playPoker();
    setIsLoading(false);
    if (ok && body) {
      window.open(body.url, '_self');
    }

    handleResponseError(error);
  };

  const handleBetClick = (): void => {
    // dispatch(setShowSubMenu(false));
    // dispatch(setShowCashierMenu(false));
    // dispatch(setShowHomeMenu(false));
    // dispatch(setShowBetForm(true));
    // dispatch(setIsShowChatSubMenu(false));
    navigate('/bet');
  };
  const handleMenuClick = (): void => {
    dispatch(setShowSubMenu(!isShowSubMenu));
    dispatch(setShowCashierMenu(false));
    dispatch(setShowHomeMenu(false));
    dispatch(setIsShowChatSubMenu(false));
  };
  const handleCashierClick = (): void => {
    // dispatch(setShowSubMenu(false));
    // dispatch(setShowHomeMenu(false));
    // dispatch(setIsShowChatSubMenu(false));
    // dispatch(setShowCashierMenu(!isShowCashierMenu));
    if (isUserLoggedIn) {
      dispatch(setShowSubMenu(false));
      dispatch(setShowHomeMenu(false));
      dispatch(setIsShowChatSubMenu(false));
      if (!currentUser?.isTester) {
        if (
          !currentUser?.kyc ||
          currentUser.kyc.status === 'INPROGRESS' ||
          currentUser.kyc.status === 'RETRY'
        ) {
          showConfirmModal({
            title: t('popup.kyc.title.required'),
            content: <p>{t('popup.kyc.message.kycRequired')}</p>,
            width: 360,
            icon: <WarningIcon />,
            onOk: () => {
              navigate('/kyc');
            },
            okText: t('popup.buttons.ok'),
            cancelText: t('popup.buttons.cancel'),
          });
          return;
        }
        if (currentUser.kyc.status === 'REJECTED') {
          showInfoModal({
            title: t('popup.kyc.title.required'),
            content: <p>{t('popup.kyc.message.rejected')}</p>,
            width: 360,
            icon: <WarningIcon />,
          });
          return;
        }
        if (currentUser.kyc.status === 'PENDING') {
          showInfoModal({
            title: t('popup.kyc.title.required'),
            content: <p>{t('popup.kyc.message.underReview')}</p>,
            width: 360,
            icon: <WarningIcon />,
          });
          return;
        }
      }
      dispatch(setShowCashierMenu(!isShowCashierMenu));
    } else {
      dispatch(onChangeAuthPage(0));
    }
    if (isPhone) {
      window.scrollTo(0, 0);
    }
  };

  const handleChatBoxClick = () => {
    dispatch(setShowSubMenu(false));
    dispatch(setShowHomeMenu(false));
    dispatch(setShowCashierMenu(false));
    dispatch(setIsShowChatSubMenu(!isShowChatSubMenu));
  };

  const handleCasinoClick = () => {
    if (isCasino) {
      navigate('/');
    } else {
      navigate('/casino');
    }
  };

  const handleBackClick = () => {
    navigate('/casino');
  };
  const handleBackStreamingClick = () => {
    navigate(-1);
  };

  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (searchParams.get('poker') === 'true' && window.innerWidth <= 1024) {
      searchParams.delete('poker');
      setSearchParams(searchParams);
      checkKYC(handlePokerClick);
    }
  }, []);

  const onCloseCashier = () => {
    dispatch(setShowCashierMenu(false));
  };

  return (
    <div className="footer-menu flex-row items-center justify-center">
      <div className="menu items-center justify-around">
        <div className="relative">
          {!((platform.isDesktop || platform.isLargeDesktop) && !platform.isLaptop) && (
            <HomeSubMenu />
          )}

          <ConditionButton
            className={`flex-col items-center menu-item gap-1 ${
              isShowHomeMenu && 'btn-show-form__active'
            }`}
            onClick={handlePokerClick}
            content={
              <>
                <img src={poker} alt={IMG_ALT} className="w-5 h-5" />
                <span>{t('footerMenu.poker')}</span>
              </>
            }
            testerCheck={true}
            isSkipCheckOnClick
          />
        </div>
        {!isCasino && !isStreaming && !isShowAllStreaming && (
          <div className="relative">
            {/* {!((platform.isDesktop || platform.isLargeDesktop) && !platform.isLaptop) && (
              <CashierSubMenu isCasino={isCasino} />
            )} */}
            <button
              className={`flex-col items-center menu-item gap-1 ${
                isShowCashierMenu && 'btn-show-form__active'
              }`}
              type="button"
              onClick={handleCashierClick}
              disabled={!isUserLogin && isCasino}
            >
              <FaWallet className="w-5 h-5" />
              <span>{t('footerMenu.cashier.title')}</span>
            </button>
          </div>
        )}
        <button
          className="flex-col items-center menu-item gap-1"
          type="button"
          onClick={handleCasinoClick}
        >
          <img
            src={
              !isCasino
                ? currentTheme === 'dark'
                  ? casino
                  : casino_dark
                : currentTheme === 'dark'
                ? home
                : home_dark
            }
            alt={IMG_ALT}
            className="w-5 h-5"
          />
          <span>{isCasino ? t('header.home') : t('header.casino')}</span>
        </button>
        {isStreaming && (
          <button
            className="flex-col items-center menu-item gap-1"
            type="button"
            onClick={() => navigate('/')}
          >
            <img
              src={currentTheme === 'dark' ? home : home_dark}
              alt={IMG_ALT}
              className="w-5 h-5"
            />
            <span>{t('header.home')}</span>
          </button>
        )}

        {isShowAllPage && (
          <button
            className={`flex-col items-center menu-item gap-1`}
            type="button"
            onClick={handleBackClick}
          >
            <GiReturnArrow className="w-5 h-5" />
            <span>{t('header.back')}</span>
          </button>
        )}
        {isShowAllStreaming && (
          <button
            className={`flex-col items-center menu-item gap-1`}
            type="button"
            onClick={handleBackStreamingClick}
          >
            <GiReturnArrow className="w-5 h-5" />
            <span>{t('header.back')}</span>
          </button>
        )}
        {!isCasino && !isStreaming && !isBetPage ? (
          <div className="relative">
            <button
              className={`flex-col items-center menu-item gap-1 ${
                isShowBetForm && 'btn-show-form__active'
              }`}
              type="button"
              onClick={handleBetClick}
            >
              <FaCubes className="w-5 h-5" />
              <span>{t('footerMenu.bet')}</span>
            </button>
            <p className="amount-bet">{bets.length + futureBets.length}</p>
          </div>
        ) : (
          <button
            className={`flex-col items-center menu-item gap-1`}
            type="button"
            onClick={handleBack}
          >
            <GiReturnArrow className="w-5 h-5" />
            <span>{t('header.back')}</span>
          </button>
        )}
        <div className="relative">
          {!((platform.isDesktop || platform.isLargeDesktop) && !platform.isLaptop) && (
            <SubFooterMenu onShowChangePasswordPage={onShowChangePasswordPage} />
          )}
          <button
            className={`flex-col items-center menu-item gap-1 ${
              isShowSubMenu && 'btn-show-form__active'
            }`}
            type="button"
            onClick={handleMenuClick}
          >
            <BiMenu className="w-5 h-5" />
            <span>{t('footerMenu.menu')}</span>
          </button>
        </div>
      </div>
      <CashierModal
        isOpen={isShowCashierMenu}
        onCancel={handleCashierClick}
        onClose={onCloseCashier}
      />
      {isLoading && (
        <div className="overlay">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default FooterMenu;
